
import React, { Component } from 'react';
import { Header } from './header.js';
import { Footer } from './footer.js';
import './activation.css';

let faqActivation = [];

export class ActivationNoticeAfterRegistration extends Component {
  render() {
    return (
      <div className="Landing" id="contentId">
        <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
        <div className="ContentWithBackground">
          <div className="content" id="content">
            <div className=" marginTop30">
              <div className="landingContentText">
                <p>Wir haben eine Aktivierungsmail an die von Ihnen genannte E-Mail-Adresse gesendet.</p>
                <p>Bitte klicken Sie auf den Link in dieser E-Mail, um Ihren Account zu aktivieren.</p>
              </div>
            </div>
          </div>
        </div>
        <Footer faqs={faqActivation} />
      </div>
    );
  }
}

export class ActivationNotice extends Component {
  handleResendClick = (e) => {
    e.preventDefault();
    let storedUser = localStorage.getItem('verification_user');
    if (storedUser !== null) {
      let user = JSON.parse(storedUser);
      if (user.email_invalid) {
        fetch(`/api/resend-verification?username=${user.username}`)
          .then(resp => resp.json())
          .then(json => {
            if (json.success) {
              alert('E-Mail mit Aktivierungslink wurde soeben versendet.');
              this.props.history.replace('/');
            }
          });
      }
    }
  };

  render() {
    return (
      <div className="Landing" id="contentId">
        <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
         <div className="ContentWithBackground">
          <div className="content" id="content">
            <div className=" marginTop30">
              <div className="landingContentText">
                <p>Ihr Account ist noch nicht aktiviert.</p>
                <p>Bitte klicken Sie auf den Aktivierungslink in der von uns gesendeten E-Mail an die von Ihnen angegebene E-Mail-Adresse.</p>
                <a href="#resend" onClick={this.handleResendClick}>Aktiverungslink erneut senden</a>
              </div>
            </div>
          </div>
        </div>
        <Footer faqs={faqActivation} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/activation.js